var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect } from 'react';
import { SmartCheck, SmartChatTypes, AuthTypes } from '../states';
import { useSession } from '@lendi/lala-react';
import { sendMessageWithTypingDecorator } from '../decorators';
import { NEW_CUSTOMER_CHECK_MESSAGE, PHONE_VALIDATION_SUCCESS_MESSAGE_2_WITHOUT_THANKS } from '../Constants';
import { formatPhone } from '../utils';
import { useChatAuthAnalytics } from '../../../../analytics';
import { PRIVACY_POLICY_MESSAGE } from '../Constants/index';
import { useError } from '../../../../providers/ErrorProvider/context';
export var useCheckExistingCustomer = function (smartChatState, chatDispatch, authDispatch) {
    var checkpoint = smartChatState.checkpoint, phoneNumber = smartChatState.phoneNumber, messages = smartChatState.messages;
    var sendCode = useSession().sendCode;
    var onException = useError().onException;
    // We get lost the SmartChat State once user is verified, so we need to track it via AnalyticsProvider.
    var setIsExistingCustomer = useChatAuthAnalytics().setIsExistingCustomer;
    function checkNewCustomer() {
        return __awaiter(this, void 0, void 0, function () {
            var isExist, oldIndex, err_1, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        isExist = false;
                        setIsExistingCustomer(isExist);
                        oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                        if (!isExist) return [3 /*break*/, 6];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        authDispatch({ type: AuthTypes.SEND_CODE });
                        return [4 /*yield*/, sendCode(phoneNumber)];
                    case 2:
                        _a.sent();
                        authDispatch({ type: AuthTypes.SENT_CODE });
                        return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, "".concat(PHONE_VALIDATION_SUCCESS_MESSAGE_2_WITHOUT_THANKS, " ").concat(formatPhone(phoneNumber)), ++oldIndex)];
                    case 3:
                        _a.sent();
                        chatDispatch({ type: SmartChatTypes.NEXT_SMART_STATE, payload: SmartCheck.ON_CODE_VALIDATION_CHECK });
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        chatDispatch({ type: SmartChatTypes.SET_PREVIOUS_CHECKPOINT_BEFORE_ERROR });
                        chatDispatch({ type: SmartChatTypes.NEXT_SMART_STATE, payload: SmartCheck.ON_ERROR_CHECK });
                        authDispatch({ type: AuthTypes.ERROR, payload: err_1 });
                        onException(new Error("@lendi/chat: SmartChat: unable to send code: ".concat(err_1)));
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 9];
                    case 6: 
                    // we retrieve the index of the previousMessage to calculate the index for next bot message.
                    return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, PRIVACY_POLICY_MESSAGE, ++oldIndex)];
                    case 7:
                        // we retrieve the index of the previousMessage to calculate the index for next bot message.
                        _a.sent();
                        return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, NEW_CUSTOMER_CHECK_MESSAGE, ++oldIndex)];
                    case 8:
                        _a.sent();
                        chatDispatch({ type: SmartChatTypes.NEXT_SMART_STATE, payload: SmartCheck.ON_NAME_CHECK });
                        _a.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        err_2 = _a.sent();
                        chatDispatch({ type: SmartChatTypes.SET_PREVIOUS_CHECKPOINT_BEFORE_ERROR }); // set the current checkpoint as previousCheckpoint on getting error
                        chatDispatch({ type: SmartChatTypes.NEXT_SMART_STATE, payload: SmartCheck.ON_ERROR_CHECK });
                        chatDispatch({ type: SmartChatTypes.SHOW_FATAL_ERROR_PAGE });
                        onException(new Error("@lendi/chat: SmartChat: error captured while checking the existence of the provided phone number: ".concat(err_2)));
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        if (checkpoint === SmartCheck.ON_NEW_CUSTOMER_CHECK) {
            checkNewCustomer();
        }
    }, [checkpoint]);
};
//# sourceMappingURL=useCheckExistingCustomer.js.map